import classNames from "classnames";
import React from "react";

type Props = Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> & {
    id: string;
    label: React.ReactNode;
};

export const Switch = React.forwardRef<HTMLInputElement, Props>(({
    className,
    id,
    label,
    ...rest
}, ref) => (
    <div className={classNames("custom-switch custom-control", className)}>
        <input
            type="checkbox"
            id={id}
            className="custom-control-input"
            ref={ref}
            {...rest} />
        <label className="custom-control-label" htmlFor={id}>
            {
                label
            }
        </label>
    </div>
));
